import { useMemo } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import styles from "./index.module.scss";

export default function SideNews({
  title = "Блог компании",
  filterId = 0,
  hideDate = false,
}) {
  const { lastNews } = useSelector((state) => state.content);

  const filteredNews = useMemo(() => {
    if (filterId) {
      return lastNews.filter(({ ID }) => ID !== filterId);
    }
    return lastNews.slice(0, 3);
  }, [lastNews]);

  return (
    <div>
      <h2 className={styles.Title}>{title}</h2>
      <div className={styles.News}>
        {filteredNews.map((item) => (
          <Link key={item.ID} href={item.DETAIL_PAGE_URL}>
            <a className={styles.Item}>
              <div className={styles.Image}>
                <img src={item.PICTURE_SRC} />
              </div>
              <div className={styles.Info}>
                <div className={styles.Name}>{item.NAME}</div>
                <div className={styles.Bottom}>
                  {!hideDate && `${item.FORMATTED_DATE} · `}
                  {item.SECTION.NAME}
                </div>
              </div>
            </a>
          </Link>
        ))}
      </div>
      <Link href="/articles">
        <a>Все статьи и новости</a>
      </Link>
    </div>
  );
}
